'use client';

import type { FC } from 'react';
import { CircularProgress } from '../CircularProgress/CircularProgress';
import { Button } from '../Button/Button';
import type { ButtonProps } from '../Button/Button';
import { WishlistButtonIcon } from './WishlistButton.icon';

export type WishlistButtonProps = {
  /** set active state on wishlist button */
  isActive: boolean;
  /**
   * button loading state
   * @default false
   */
  loading?: boolean;
} & ButtonProps;

export const WishlistButton: FC<WishlistButtonProps> = ({
  isActive = false,
  variant,
  size,
  loading = true,
  className,
  children,
  onClick,
  ...rest
}) => (
  <Button
    {...rest}
    variant={variant}
    size={size}
    onClick={onClick}
    className={className}
    aria-label={children ? undefined : rest['aria-label']}
  >
    {children}
    {loading ? (
      <CircularProgress />
    ) : (
      <WishlistButtonIcon
        // only set icon size if button size param is "small" otherwise use the default icon size set via the button styles
        // and therefore add the icon-emp class to match the default icon size rules from the button styles
        className={`${size === 'small' ? 'size-3' : 'icon-emp'} ${isActive ? 'c_wishlist-icon-active animate-beat' : 'c_wishlist-icon'}`}
      />
    )}
  </Button>
);
